

const page_strings = {
	"menu_item_developer" : "開発者", // 首頁上方選單
	"menu_item_service" : "サービス", // 首頁上方選單
	"menu_item_brands" : "ブランド", // 首頁上方選單
	"menu_item_medium" : "MEDUIM", // 首頁上方選單
	"menu_item_home" : "ホーム", // 支援品項上方選單

	"page_company_name" : "台湾インテリジェントホーム", // 公司名稱
	// fallback: page_title
	"page_title" : "MAKE SMART HOME SMARTER", // 首頁標語
	"download_on": "DOWNLOAD ON",
	"page_subtitle" : "シングルアプリでスマートホームを管理する", // 首頁副標語
	"our_service_title" : "当社のサービス", // 服務頁標題
	"our_service_subtitle" : "TIHでできること", // 服務頁副標題
	"MaidWhite" : "メイドホワイト", // Maid White 項目標題
	"maid_white_desc" : "メイドホワイトは、IoTデバイスのソフトウェアプロトコルを統合するプラットフォームです。 \n\nメイドホワイトを使用すると、アプライアンス企業または関心のある開発者は、RESTful APIを介してIoTデバイスを簡単に制御できます。MQTTや他の企業が独自に開発したプロトコルなど、多くのプロトコルを学ぶ必要はありません。", // Maid White 項目內文
	"meet_it" : "お試しください", // MaidWhit項目底部
	"app_dev" : "アプリ開発", // APP 開發項目標題
	"app_dev_desc" : "TIHはアプリを開発し、使用するモジュールまたはクラウドに関する提案を提供し、IoT分野への参入に関心のある企業とIoT アプリ実装の経験を共有します。", // APP 開發項目內文
	"Ryoku" : "Ryoku Cloud", // Ryoku 項目標題
	"ryoku_desc" : "Ryoku Cloudは、軽いリレーサービスです。他のIoTリレーサーバーとは異なり、開発者のアカウントを使用する前に登録する必要はありません。さらに、HTTP、HTTP / 2、MQTT、Web Socketなどのさまざまなインターフェイスを提供します。RyokuCloudは、ハッカソンまたはPOC（概念実証）に使用するのに適しています。", // Ryoku 項目內文
	"ryoku_simulator" : "Ryokuシミュレーター", // Ryoku 模擬器標題
	"ryoku_simulator_desc" : "Ryokuシミュレーターは、Webソケットを介したRyoku Cloudへのアクセスを支援するオープンソースプロジェクトです。\n\nソフトウェア開発者は、Ryokuシミュレーターを使用してデバイスを正常に制御したかどうかをテストでき、ソフトウェア開発のコストを削減できます。", // Ryoku 模擬器項目內文
	"about_numbers_title" : "ナンバートーク", // 數字會說話
	"about_numbers_subtitle" : "TIH IoTの進歩", // 數字會說話副標題
	"number_of_supported_brands" : "TIHサービスがサポートするブランド", // 支援品牌數量
	"number_of_requests" : "TIHクラウドにリクエストが送信されました", // 請求數量
	"number_of_supported_devices" : "TIHクラウドをサポートするデバイス", // 設備支援數量
	"subscribe_by_email" : "電子メールによる電子ニュースを購読", // 訂閱電子報
	"subscribe_text_or" : "または", // 訂閱電子報或追蹤臉書的或
	"follow_us_on_facebook" : "フェイスブックでフォローしてください", // 追蹤臉書
	"tih_copyright" : "Copyright © 2024 TIH Corp. All rights reserved", // 版權聲明
	"privacy_policy" : "個人情報保護方針", // 隱私政策連結
	"supported_brands_title" : "サポートされているブランド", // 支援品項頁面首頁
	"model" : "モデル", // 支援品項型號
	"device_type" : "デバイスタイプ", // 支援品項設備類別
	"remarks" : "備考", // 支援品項備註
	"popup_subtitle" : "スマートアプライアンスを取り扱います。", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_can_alse" : "メイドホワイトもできます", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_action_en" : "「ねぇグーグル、ランプをつけて。」", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_action_local" : "「幫我叫女僕小白。」", // 首頁點選MaidWhite Meet it的彈出視窗中
	"popup_and_more" : "もっと...", // 首頁點選MaidWhite Meet it的彈出視窗中






	"text_reveived_subscribe_mail_request" : "受け取りました！", // 收到使用者要求訂閱電子報的訊息

	"html_description": "私たちは、台湾インテリジェントホーム、スマートホームの統合に専念している会社です。 私たちの目的は、台湾のソフトウェア産業チェーンを作ることです。",
	"html_title": "台湾インテリジェントホーム",
}

const privacy_policy ={
	"privacy_policy_title": "プライバシーポリシー",
	"privacy_policy_version": "隱私權政策版本：2017101001-ja_jp",
	"privacy_policy_content_1": "台湾インテリジェントホーム（Taiwan Intelligent Home Corp.以下、TIH、当社といいます）はお客様の意思やプライバシーを尊重し、個人情報を安全に保護するよう努めております。なお、お客様がTIHのウェブサイトとサービスをご利用されている際は、本プライバシーポリシーに同意されているものとみなします。ご同意いただけない場合は、本サービスの利用はご遠慮ください。内容に関するご質問は、メールで受け付けております。",
	"privacy_policy_content_2_1": "個人情報の収集方法と内容について",
	"privacy_policy_content_2_2_1": "お客様がTIHのサービスをご利用されている際には、当社は以下の情報収集を行っております。",
	"privacy_policy_content_2_2_2_1": "メールアドレス",
	"privacy_policy_content_2_2_2_2": "デバイスに関する情報",
	"privacy_policy_content_2_2_2_3": "デバイスへのログイン情報",
	"privacy_policy_content_2_2_2_4": "インターネットへのリクエスト（ＩＰアドレス、ブラウザタイプと言語、日付と時間など）",
	"privacy_policy_content_3_1": "お客様から取得された個人情報の取扱いについて",
	"privacy_policy_content_3_2_1": "当社は、お客様から取得された個人情報を、以下の目的のために利用しております。",
	"privacy_policy_content_3_2_2_1": "商品とサービスの提供、維持、改善",
	"privacy_policy_content_3_2_2_2": "新しい商品とサービスの開発",
	"privacy_policy_content_3_2_2_3": "ユーザー体験とマーケティングの分析",
	"privacy_policy_content_3_2_2_4_1": "お客様の同意を得た上で、信頼される第三者の開発者に、以下のデバイス制御の権限を提供しております。",
	"privacy_policy_content_3_2_2_4_2_1": "デバイスをコントロール",
	"privacy_policy_content_3_2_2_4_2_2": "デバイスの状態をアクセス",
	"privacy_policy_content_3_2_2_4_2_3": "デバイス制御の記録をアクセス",
	"privacy_policy_content_3_2_2_5": "他にお客様の同意された用途",
	"privacy_policy_content_3_2_2_6": "法令によって認められている場合、関係当局に情報提供を行うこととされております",
	"privacy_policy_content_4_1": "国境を越えたデータフローについて",
	"privacy_policy_content_4_2": "TIHは、異なる国と地域に設置されたサーバーを利用しております。つまり、当社は台湾或い台湾以外に設置されたサーバーによって、お客様の個人情報を処理しております。",
	"privacy_policy_content_5_1": "クッキー（Cookie）及び類似の技術について",
	"privacy_policy_content_5_2": "TIHはクッキー（Cookie）を利用することによって、オーオース（Oauth）のログインを行い、お客様の訪問回数、またはウェーブページ上の機能へのアクセスを追跡されております。",

}

var strings = {...page_strings, ...privacy_policy}

export default strings;
